var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M1740.073,5156.132a6.464,6.464,0,1,0,6.464,6.464A6.437,6.437,0,0,0,1740.073,5156.132Zm7.49-9.132h-15.083a7.707,7.707,0,0,0-7.7,7.7V5170.8a7.708,7.708,0,0,0,7.7,7.7h15.083a7.708,7.708,0,0,0,7.7-7.7V5154.8a7.686,7.686,0,0,0-2.257-5.438A7.787,7.787,0,0,0,1747.563,5147Zm-7.49,25.549a9.953,9.953,0,1,1,9.952-9.953A9.962,9.962,0,0,1,1740.073,5172.549Zm10.158-17.648a2.36,2.36,0,1,1,2.36-2.36A2.387,2.387,0,0,1,1750.23,5154.9Z","transform":"translate(-1724.784 -5147)","key":1})]);
}

Instagram.defaultProps = {"width":"30.474","height":"31.5","viewBox":"0 0 30.474 31.5"};

module.exports = Instagram;

Instagram.default = Instagram;
